import suiteService from 'qreventos-suite/services';

class SuiteConfig {
    evento:number = 401;
    token:string = 'bUJldXJDYnNJRVdFdVVCL3FnbmI4STNneDZuYncvaUZnVTl4cU9kQjlXaz0=';
    clientId: string = '6521aaec11-88ec-af87-df3a-aa440ed12ac154-401';

    public constructor() {
      suiteService.clientId = this.clientId;
      suiteService.token = this.token;  
    }
}

export default new SuiteConfig();
